import React from 'react';
import SecureViewer from '../SecureViewer/SecureViewer';

type Props = {
  /** ID of the policy whose document should be rendered. */
  policyId: string;
  /** CSS module prefix e.g. "policy-view" → policy-view-iframe (legacy compat). */
  variant?: 'viewer' | 'acceptance';
};

/**
 * Renders a policy attachment in the embedded SecureViewer. The viewer fetches
 * the PDF bytes through the authenticated backend (`/policies/:id/view`) so
 * the source URL never reaches the client. Watermark, blur-on-blur, no
 * download / print / right-click — see SecureViewer for details.
 */
const PolicyDocumentEmbed: React.FC<Props> = ({ policyId, variant = 'viewer' }) => {
  const wrapClass =
    variant === 'acceptance'
      ? 'policy-accept-doc-secure'
      : 'policy-view-doc-secure';
  return (
    <div className={wrapClass}>
      <SecureViewer resourceType="policy" resourceId={policyId} embedded />
    </div>
  );
};

export default PolicyDocumentEmbed;
